export const getUrlFromEnv = (envName: string) => {
  if (process.env.REACT_APP_ENV_SOURCE === "dev") {
    return process.env[envName] || "/";
  } else {
    // @ts-ignore
    return window.__RUNTIME_CONFIG__?.[envName] || "/";
  }
};
